import classes from "@Styles/components/_hero-image.module.scss";
import { CMSImageType } from "@Types/Contentful";
import Link from "@wff/components/Link";
import { BannerCaption } from "./BannerCaption";

export interface bannerProps {
  name: string;
  bannerImage: CMSImageType;
  heading: string;
  buttonText: string;
  buttonLink: string;
  caption?: string;
}
const Banner = (props: bannerProps) => {
  const { bannerImage, heading, buttonText, buttonLink, caption } = props;
  if (!bannerImage?.url) return null;

  return (
    <div
      className={`${classes["home-page-hero-slide"]} ${classes["section--slideshow"]} ${classes["slider__slide"]} ${classes["slider__slide--adjustable"]} ${classes["tns-item"]} `}
      style={{
        backgroundImage: `url("${bannerImage.url}?fm=webp&w=1920&h=1080")`,
      }}
    >
      <div
        className={`${classes["slider__inner"]} ${classes["slider__inner--alignment"]}`}
      >
        <div
          className={`${classes["slider__slide-wrapper"]} ${classes["class"]} ${classes["class"]}`}
        >
          <h1
            className={`${classes["section__heading"]} ${classes["section__heading--hero-title"]}`}
          >
            <span className={`${classes["section__title"]}`}>{heading}</span>
            <span
              className={`${classes["section__title"]} ${classes["section__title--mobile"]}`}
            >
              {heading}
            </span>
          </h1>

          <BannerCaption caption={caption} />
          {buttonText && buttonLink && (
            <Link href={buttonLink}>
              <a className={`${classes["action"]}`}>
                <span className={`${classes["section__cta"]}`}>
                  {buttonText}
                </span>
                <span
                  className={`${classes["section__cta"]} ${classes["section__cta--mobile"]}`}
                >
                  {buttonText}
                </span>
              </a>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Banner;
